import React, { createContext, useMemo, useState } from "react";

export interface CurrentDetectorContextProps {
  currentDetectorId: string | null;
  setCurrentDetectorId: (id: string | null) => void;
}

export const detectorContext = createContext<CurrentDetectorContextProps | null>(null);

// Create a Provider component for your context
export function DetectorProvider({ children }: { children: React.ReactNode }) {
  const [currentDetectorId, setCurrentDetectorId] = useState<string | null>(null);

  // Wrap your context value in useMemo for performance optimization
  const contextValue = useMemo(() => ({ currentDetectorId, setCurrentDetectorId }), [currentDetectorId]);

  return <detectorContext.Provider value={contextValue}>{children}</detectorContext.Provider>;
}
